import { render, staticRenderFns } from "./AddHelpRecord.vue?vue&type=template&id=b68fc6fe&scoped=true"
import script from "./AddHelpRecord.vue?vue&type=script&lang=js"
export * from "./AddHelpRecord.vue?vue&type=script&lang=js"
import style0 from "./AddHelpRecord.vue?vue&type=style&index=0&id=b68fc6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68fc6fe",
  null
  
)

export default component.exports